export function getBaseUrl() {
    return window.location.origin;
}
